import { LazyLoadImage } from 'react-lazy-load-image-component';

import dialogs from '../../dialogs';
import { Title } from '../../utils/title';
import Layout from './Layout';
import Entries from './contentful/Entries';
import styles from './Brand.module.scss';

import hero from './common/hero.module.scss';
import section_a from './common/section_a.module.scss';
import section_b from './common/section_b.module.scss';
import section_c from './common/section_c.module.scss';
import action_a from './common/action_a.module.scss';
import action_b from './common/action_b.module.scss';
import cards from './common/cards.module.scss';

import hero_3 from '../../assets/landing/hero/3.gif';

import section_1_lg from '../../assets/landing/section/brand/1_lg.png';
import section_1_sm from '../../assets/landing/section/brand/1_sm.png';
import section_1_svg from '../../assets/landing/section/brand/1_svg.svg';

import section_2_lg from '../../assets/landing/section/brand/2_lg.png';
import section_2_sm from '../../assets/landing/section/brand/2_sm.png';
import section_2_svg from '../../assets/landing/section/brand/2_svg.svg';

import section_3_lg from '../../assets/landing/section/brand/3_lg.png';
import section_3_sm from '../../assets/landing/section/brand/3_sm.png';
import section_3_svg from '../../assets/landing/section/brand/3_svg.svg';

import action_b_brand from '../../assets/landing/action/b_brand.svg';

import icon_star from '../../assets/landing/icons/star.svg';
import icon_graph from '../../assets/landing/icons/graph.svg';
import icon_connect from '../../assets/landing/icons/connect.svg';
import icon_sell from '../../assets/landing/icons/sell.svg';

import icon_scale from '../../assets/landing/icons/scale.svg';
import icon_move from '../../assets/landing/icons/move.svg';
import icon_container from '../../assets/landing/icons/container.svg';
import icon_hash from '../../assets/landing/icons/hash.svg';
import icon_page from '../../assets/landing/icons/page.svg';
import icon_element from '../../assets/landing/icons/element.svg';

const Hero = () => {

  const { setDialog } = dialogs.utils.useDialog();

  return (
    <div className={hero.root}>
      <div className={hero.content}>
        <div className={`${hero.title} ${hero.compact}`}>
          UGC and Reviews
          <br/>
          That Resonate
        </div>

        <div className={hero.image_3}>
          <LazyLoadImage
            src={hero_3}
            alt='video review'
          />
        </div>

        <div className={hero.text}>
          Generate authentic UGCs and product reviews with our hyper-targeted
          sampling programs.
        </div>

        <div className={hero.action}>
          <button onClick={() => setDialog('contact')}>
            Get Reviews
          </button>
        </div>

      </div>
    </div>
  );
};

const SectionA = () => {
  return (
    <div className={section_a.root}>
      <div className={section_a.content}>
        <div className={section_a.image}>
          <LazyLoadImage
            className={section_a.lg}
            src={section_1_lg}
            alt='product'
          />
          <LazyLoadImage
            className={section_a.sm}
            src={section_1_sm}
            alt='product'
          />
        </div>

        <div className={section_a.svg}>
          <LazyLoadImage
            src={section_1_svg}
            alt='review'
          />
        </div>

        <div className={section_a.title}>
          Get more reviews published...
        </div>

        <div className={section_a.text}>
          Deliver your products to our creators and receive authentic reviews that
          inspire others. These reviews will appear on major retail sites like
          Walmart, Target, and Ulta, giving your brand maximum exposure.
        </div>
      </div>
    </div>
  );
};

const SectionB = () => {
  return (
    <div className={section_b.root}>
      <div className={section_b.content}>
        <div className={section_b.image}>
          <LazyLoadImage
            className={section_b.lg}
            src={section_2_lg}
            alt='product'
          />
          <LazyLoadImage
            className={section_b.sm}
            src={section_2_sm}
            alt='product'
          />
        </div>

        <div className={section_b.svg}>
          <LazyLoadImage
            src={section_2_svg}
            alt='share'
          />
        </div>

        <div className={section_b.title}>
          Bring product page experience to social media
        </div>

        <div className={section_b.text}>
          Our creators produce <b>engaging UGC at scale</b>: authentic videos
          and photos shared across social platforms, enabling new consumers
          to discover your products on social media.
        </div>
      </div>
    </div>
  );
};

const SectionC = () => {
  return (
    <div className={section_c.root}>
      <div className={section_c.content}>
        <div className={section_c.image}>
          <LazyLoadImage
            className={section_c.lg}
            src={section_3_lg}
            alt='product'
          />
          <LazyLoadImage
            className={section_c.sm}
            src={section_3_sm}
            alt='product'
          />
        </div>

        <div className={section_c.svg}>
          <LazyLoadImage
            src={section_3_svg}
            alt='social media'
          />
        </div>

        <div className={section_c.title}>
          Increase brand awareness and reach new consumers
        </div>

        <div className={section_c.text}>
          With our unique solution your reviews are reaching new audiences
          across social media platforms, driving incremental sales and growth!
        </div>
      </div>
    </div>
  );
};

const ActionA = () => {

  const { setDialog } = dialogs.utils.useDialog();

  return (
    <div className={action_a.root}>
      <div className={action_a.content}>
        <div className={action_a.title}>
          Reviews worth sharing
        </div>

        <div className={action_a.text}>
          Connect with a curated community of creators to get more product
          reviews and shareable content that inspire consumers to become
          your customers.
        </div>

        <div className={action_a.action}>
          <button onClick={() => setDialog('contact')}>
            Get Started
          </button>
        </div>

      </div>
    </div>
  );
};

const ActionB = () => {

  const { setDialog } = dialogs.utils.useDialog();

  return (
    <div className={action_b.root}>
      <div className={action_b.content}>
        <div className={action_b.title}>
          Unlock the full potential of your product reviews
        </div>

        <div className={action_b.action}>
          <button onClick={() => setDialog('contact')}>
            Get Started
          </button>
        </div>

        <div className={action_b.image}>
          <LazyLoadImage
            src={action_b_brand}
            alt='unlock'
          />
        </div>
      </div>
    </div>
  );
};

const CardsA = () => {
  return (
    <div className={cards.root}>
      <div className={cards.title}>
        Why Chimeable?
      </div>

      <div className={`${cards.content} ${cards.col_2}`}>
        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_star}
              alt='star'
            />
          </div>

          <div className={cards.title}>
            Get Reviews
          </div>

          <div className={cards.text}>
            With us, your brand will get published reviews,
            quickly and effectively.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_graph}
              alt='graph'
            />
          </div>

          <div className={cards.title}>
            Find Creators
          </div>

          <div className={cards.text}>
            Connect with a curated community of thousands of creators
            ready to try your products and spread the word.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_connect}
              alt='connect'
            />
          </div>

          <div className={cards.title}>
            Increase Exposure
          </div>

          <div className={cards.text}>
            Get more eyeballs on your product with
            engaging UGC at scale.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_sell}
              alt='sell'
            />
          </div>

          <div className={cards.title}>
            Sell More
          </div>

          <div className={cards.text}>
            Generate more leads and convert them into sales.
          </div>
        </div>
      </div>
    </div>
  );
};

const CardsB = () => {
  return (
    <div className={`${cards.root} ${cards.alt}`}>
      <div className={cards.title}>
        Key Features
      </div>

      <div className={`${cards.content} ${cards.col_3}`}>
        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_scale}
              alt='scale'
            />
          </div>

          <div className={cards.title}>
            Scalable
          </div>

          <div className={cards.text}>
            Run campaigns at a scale through Chimeable's community and
            innovative new technology that blurs the line between written
            reviews and shareable social content.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_move}
              alt='move'
            />
          </div>

          <div className={cards.title}>
            Hyper-targeted and vetted
          </div>

          <div className={cards.text}>
            Reach your target audience to ensure product consumer match.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_container}
              alt='container'
            />
          </div>

          <div className={cards.title}>
            Review Syndication
          </div>

          <div className={cards.text}>
            We help brand get reviews from their customers and syndicate
            them across retailers and social media.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_hash}
              alt='hash'
            />
          </div>

          <div className={cards.title}>
            Engaging UGC at scale
          </div>

          <div className={cards.text}>
            Our creators produce authentic content that brings
            your products to life on social media.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_page}
              alt='page'
            />
          </div>

          <div className={cards.title}>
            Content License
          </div>

          <div className={cards.text}>
            We enable brands to repurpose UGC across your brand's
            digital channels including social, email, newsletters,
            ads and website.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_element}
              alt='element'
            />
          </div>

          <div className={cards.title}>
            White glove service
          </div>

          <div className={cards.text}>
            We handle every step from creator selection, campaign management,
            content moderation and reporting.
          </div>
        </div>
      </div>
    </div>
  );
};

const Articles = () => {
  return (
    <Entries
      limit={3}
      contentType='blog'
      image={{
        field: 'featured_image',
        altField: 'featured_image_alt',
        mode: 'cover',
      }}
      link={
        item => item
        ? `/blog/${item.slug}`
        : '/blog'
      }
      caption='All Articles'
    />
  );
};

const Cases = () => {
  return (
    <Entries
      limit={3}
      contentType='case-study'
      featured={true}
      image={{
        field: 'brand_logo',
        altField: 'brand_logo_alt',
        mode: 'contain',
      }}
      link={
        item => item
        ? `/case-studies/${item.slug}`
        : '/case-studies'
      }
      caption='All Case Studies'
    />
  );
};

const Brand = () => {
  return (
    <>
      <Title value='Brands'/>
      <Layout>
        <div className={styles.root}>
          <Hero />
          <Cases />
          <SectionA />
          <SectionB />
          <SectionC />
          <Articles />
          <ActionA />
          <CardsA />
          <CardsB />
          <ActionB />
        </div>
      </Layout>
    </>
  );
};

export default Brand;